import { THEME_MODE } from 'src/interfaces/theme';
import { SET_THEME } from '../constants/theme';

const initialState: THEME_MODE = THEME_MODE.DARK;

export const themeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_THEME:
      const { theme } = action.payload;
      return theme;

    default:
      return state;
  }
};
